import { ApiRoutes } from '@/shared/models/api-routes.interface';

type AuthExceptionRouteSelector = (apiRoutes: ApiRoutes) => string;

export const AUTH_EXCEPTION_ROUTE_SELECTORS: readonly AuthExceptionRouteSelector[] = [
  (apiRoutes) => apiRoutes.gateway.otp.send,
  (apiRoutes) => apiRoutes.gateway.otp.verify,
  (apiRoutes) => apiRoutes.gateway.mobileAuth.register,
  (apiRoutes) => apiRoutes.gateway.mobileAuth.refreshToken,
  (apiRoutes) => apiRoutes.gateway.lookups.subscriptionPlans,
  (apiRoutes) => apiRoutes.gateway.interestRegistration.register,
  (apiRoutes) => apiRoutes.gateway.appContent.faq.list,
  (apiRoutes) => apiRoutes.gateway.appContent.helpSupport.contact,
  (apiRoutes) => apiRoutes.gateway.appContent.legalDocument.list,
];

export const getAuthExceptionRoutes = (apiRoutes: ApiRoutes): readonly string[] =>
  AUTH_EXCEPTION_ROUTE_SELECTORS.map((selectRoute) => selectRoute(apiRoutes));

export const isAuthExceptionRoute = (requestUrl: string, apiRoutes: ApiRoutes): boolean =>
  getAuthExceptionRoutes(apiRoutes).some((route) => requestUrl.includes(route));

export const isRefreshTokenRoute = (requestUrl: string, apiRoutes: ApiRoutes): boolean =>
  requestUrl.includes(apiRoutes.gateway.mobileAuth.refreshToken);
